import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "zh", "cn"],

  // Used when no locale matches
  defaultLocale: "en",
  pathnames: {
    "/": {
      en: "/",
      zh: "/",
      cn: "/",
    },
    "/about": {
      en: "/about",
      zh: "/about",
      cn: "/about",
    },
    "/privacy": {
      en: "/privacy",
      zh: "/privacy",
      cn: "/privacy",
    },
    "/services": {
      en: "/services",
      zh: "/services",
      cn: "/services",
    },
    "/services/accounting": {
      en: "/services/accounting",
      zh: "/services/accounting",
      cn: "/services/accounting",
    },
    "/services/audit": {
      en: "/services/audit",
      zh: "/services/audit",
      cn: "/services/audit",
    },
    "/services/corporate-tax": {
      en: "/services/corporate-tax",
      zh: "/services/corporate-tax",
      cn: "/services/corporate-tax",
    },
    "/services/individual-tax": {
      en: "/services/individual-tax",
      zh: "/services/individual-tax",
      cn: "/services/individual-tax",
    },
    "/services/tax-planning": {
      en: "/services/tax-planning",
      zh: "/services/tax-planning",
      cn: "/services/tax-planning",
    },
    "/services/immigration": {
      en: "/services/immigration",
      zh: "/services/immigration",
      cn: "/services/immigration",
    },
    "/career": {
      en: "/career",
      zh: "/career",
      cn: "/career",
    },
    "/payment": {
      en: "/payment",
      zh: "/payment",
      cn: "/payment",
    },
    "/contact": {
      en: "/contact",
      zh: "/contact",
      cn: "/contact",
    },
    // Catch-all to handle dynamic routes
    "/*": {
      en: "/*",
      zh: "/*",
      cn: "/*",
    },
  },
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export type Locale = (typeof routing.locales)[number];
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);
